<template>
  <div class="loginForm">
    <label for="userId">아이디</label>
    <input
      type="text"
      name="userId"
      id="userId"
      v-model="userId"
      class="w-full p-2 border border-gray-300 rounded appearance-none"
    />
  </div>

  <div class="loginForm">
    <label for="password">비밀번호</label>
    <input
      type="password"
      name="password"
      id="password"
      v-model="password"
      class="w-full p-2 border border-gray-300 rounded appearance-none"
      @keyup.enter="onClickLogin"
    />
  </div>
  <div class="loginForm">
    <button
      type="button"
      class="p-2 border border-gray-300 rounded w-full"
      @click="onClickLogin"
    >
      login
    </button>
  </div>
</template>
<script>
import router from "@/routes";
import { mapActions } from "vuex";

const userStore = "userStore";

export default {
  name: "LoginForm",
  data() {
    return {
      userId: "test",
      password: "test1234",
    };
  },
  methods: {
    ...mapActions(userStore, ["AC_LOGIN"]),

    async onClickLogin() {
      const formBody = {
        userName: this.userId,
        password: this.password,
      };
      await this.AC_LOGIN(formBody)
        .then(() => {
          router.push("/");
        })
        .catch((e) => {
          if (e.status === 401) {
            alert("아이디 및 비밀번호를 확인해주시기 바랍니다");
          } else if (e.status === undefined) {
            alert("잠시 후 다시 시도해주시기 바랍니다.");
          }
        });
    },
  },
};
</script>
<style>
.loginForm {
  max-width: 280px;
  width: 100%;
  margin: 0 auto 1em auto;
  display: block;
  > label {
    display: block;
    text-align: left;
  }
}
</style>
